import { render, staticRenderFns } from "./ModifyProductPower.vue?vue&type=template&id=4e8156a0&scoped=true&"
import script from "./ModifyProductPower.vue?vue&type=script&lang=js&"
export * from "./ModifyProductPower.vue?vue&type=script&lang=js&"
import style0 from "./ModifyProductPower.vue?vue&type=style&index=0&id=4e8156a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8156a0",
  null
  
)

export default component.exports